import React from "react";
import { useLang } from "@/context/LangContext";
import { cn } from "@/lib/utils";

export function LanguageToggle({ className, variant = "light" }) {
    const { lang, setLang } = useLang();
    const dark = variant === "dark";
    return (
        <div
            data-testid="language-toggle"
            className={cn(
                "inline-flex items-center rounded-full p-0.5 text-xs font-bold",
                dark ? "bg-white/15" : "bg-bio-bg-alt border border-bio-border-subtle",
                className,
            )}
        >
            {["es", "en"].map((l) => (
                <button
                    key={l}
                    data-testid={`lang-${l}`}
                    onClick={() => setLang(l)}
                    className={cn(
                        "px-2.5 py-1 rounded-full transition-colors uppercase",
                        lang === l
                            ? dark
                                ? "bg-white text-bio-primary"
                                : "bg-bio-primary text-white"
                            : dark
                                ? "text-white/80"
                                : "text-bio-text-secondary",
                    )}
                >
                    {l}
                </button>
            ))}
        </div>
    );
}
